import template from './bottom-block.dot';
const bottomBlockTemplate = template.default ? template.default : template;
export { bottomBlockTemplate };
